import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom"; // React Router DOM instead of Next.js
import { fetchTaskById } from "../../../Redux/Slice/TaskMasterSlice";

const TaskMasterDetails = () => {
  const { id } = useParams(); // Task ID from route
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { TaskByIdData } = useSelector((state) => state.TaskMaster);

  useEffect(() => {
    dispatch(fetchTaskById(id));
  }, [dispatch, id]);

  const taskDetails = {
    TaskName: TaskByIdData?.data?.TastName || "",
    Description: TaskByIdData?.data?.Description || "",
    Duration: TaskByIdData?.data?.Duration || "",
    DurationeType: TaskByIdData?.data?.DurationeType || "",
    ProjectName: TaskByIdData?.data?.Project?.project_name || "",
    TaskType: TaskByIdData?.data?.Type || "",
    TeamMemberName: (TaskByIdData?.data?.TeamId || [])
      .map((member) => member?.Name)
      .join(", "),
    SubTask: (TaskByIdData?.data?.SubTask || [])
      .map((sub) => sub?.SubTaskName)
      .join(", "),
  };

  const descriptionRef = useRef(null);

  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.style.height = "auto";
      descriptionRef.current.style.height =
        descriptionRef.current.scrollHeight + "px";
    }
  }, [taskDetails.Description]);

  const handleSubmit = () => {
    navigate(`/taskmaster/update/${id}`);
  };

  return (
    <div className="p-2 lg:p-4 bg-gray-100 min-h-screen">
      <div className="flex justify-center mb-5">
        <h3 className="inline-block text-xl sm:text-2xl xl:text-3xl font-medium main_title_page text-white px-6 py-2 rounded shadow">
          TASK DETAILS
        </h3>
      </div>

      <div className="form_home shadow-lg rounded-xl p-8 border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
          {/* Task Name */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Task Name
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.TaskName || ""}
              readOnly
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Description
            </label>
            <textarea
              ref={descriptionRef}
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500 resize-none overflow-hidden"
              value={taskDetails?.Description || ""}
              readOnly
              rows="1"
            ></textarea>
          </div>

          {/* Duration */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Duration
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.Duration || ""}
              readOnly
            />
          </div>

          {/* Duration Type */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Duration Type
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.DurationeType || ""}
              readOnly
            />
          </div>

          {/* Project Name */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Project Name
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.ProjectName || ""}
              readOnly
            />
          </div>

          {/* Task Type */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Task Type
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.TaskType || ""}
              readOnly
            />
          </div>

          {/* Team Members */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Team Members
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.TeamMemberName || ""}
              readOnly
            />
          </div>

          {/* Sub-Tasks */}
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
              Sub-Tasks
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none focus:border-blue-500"
              value={taskDetails?.SubTask || "NO SUBTASKS"}
              readOnly
            />
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <button
            type="button"
            className="bg-[#112A47] text-white px-3 py-2 rounded-md text-md font-semibold hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
            onClick={handleSubmit}
          >
            UPDATE
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskMasterDetails;
